// Shared labels + Tailwind styles for project type and construction status.
// Mirrors UNIT_STATUS_STYLES so the index, drawer and detail page stay in sync.

// The shared <Card> primitive is a dark glass surface (built for the auth
// screens). Inventory pages live on a light theme, so override it to a clean
// white card wherever Card is used here.
export const LIGHT_CARD = "rounded-xl border border-slate-200 bg-white shadow-none backdrop-blur-none"

export const PROJECT_TYPES = [
  { value: "residential", label: "Residential", badge: "bg-blue-100 text-blue-800" },
  { value: "commercial", label: "Commercial", badge: "bg-amber-100 text-amber-800" },
  { value: "agricultural", label: "Agricultural", badge: "bg-emerald-100 text-emerald-800" },
  { value: "plot", label: "Plot", badge: "bg-violet-100 text-violet-800" },
]

export const PROJECT_TYPE_MAP = Object.fromEntries(PROJECT_TYPES.map((t) => [t.value, t]))

export const PROJECT_STATUSES = [
  { value: "new_launch", label: "New launch", dotColor: "#a78bfa", badge: "bg-violet-100 text-violet-800" },
  { value: "under_construction", label: "Under construction", dotColor: "#fbbf24", badge: "bg-amber-100 text-amber-800" },
  { value: "ready_to_move", label: "Ready to move", dotColor: "#38bdf8", badge: "bg-sky-100 text-sky-800" },
  { value: "sold_out", label: "Sold out", dotColor: "#94a3b8", badge: "bg-slate-200 text-slate-700" },
]

export const PROJECT_STATUS_MAP = Object.fromEntries(PROJECT_STATUSES.map((s) => [s.value, s]))

// Deterministic avatar tint for an assignee, derived from their name.
const AVATAR_TINTS = [
  "bg-blue-100 text-blue-700",
  "bg-emerald-100 text-emerald-700",
  "bg-violet-100 text-violet-700",
  "bg-amber-100 text-amber-700",
  "bg-rose-100 text-rose-700",
  "bg-teal-100 text-teal-700",
]

export function avatarTint(seed = "") {
  let hash = 0
  for (let i = 0; i < seed.length; i += 1) hash = (hash * 31 + seed.charCodeAt(i)) & 0xffffffff
  return AVATAR_TINTS[Math.abs(hash) % AVATAR_TINTS.length]
}
